import { Checkbox, DatePicker, Form } from "antd";
import React from "react";
import { PublicationsQuery } from "../api/publications";
import { Publication } from "../api/publications.model";
import "./PublicationFilters.css";

export interface PublicationFiltersProps {
  publications: Publication[] | null;
  onChange?(query: PublicationsQuery): void;
}

export const PublicationFilters: React.FC<PublicationFiltersProps> = (
  props
) => {
  const [form] = Form.useForm();

  const onChange = () => {
    const values = form.getFieldsValue();
    console.log(values);

    if (props.onChange) {
      props.onChange({
        types: values["types"],
        publicationYear: values["publicationYear"]?.year(),
      });
    }
  };

  return (
    <Form
      form={form}
      className="publication-filters"
      layout="vertical"
      initialValues={{
        types: ["dataset", "journal", "conference"],
      }}
      onFieldsChange={onChange}
    >
      <Form.Item name="types" label="Publication Type">
        <Checkbox.Group
          options={[
            { label: "Dataset", value: "dataset" },
            { label: "Journal Article", value: "journal" },
            { label: "Conference Paper", value: "conference" },
          ]}
        />
      </Form.Item>
      <Form.Item name="publicationYear" label="Publication Year">
        <DatePicker.YearPicker />
      </Form.Item>
    </Form>
  );
};
